import { SVGProps } from 'react';

const YearMakeModelIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg height="20" width="20" fill="none" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect height="5" width="16" rx="1" stroke="currentColor" strokeWidth="1.5" x="2" y="3" />
      <path
        d="M4.75 8.5C4.75 8.36193 4.86193 8.25 5 8.25H15C15.1381 8.25 15.25 8.36193 15.25 8.5V12C15.25 12.1381 15.1381 12.25 15 12.25H5C4.86193 12.25 4.75 12.1381 4.75 12V8.5Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M7.75 12.5C7.75 12.3619 7.86193 12.25 8 12.25H12C12.1381 12.25 12.25 12.3619 12.25 12.5V15.9994C12.25 16.1375 12.1381 16.2494 12 16.2494H8C7.86193 16.2494 7.75 16.1375 7.75 15.9994V12.5Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    </svg>
  );
};

export default YearMakeModelIcon;
